import React, {Component} from 'react';
import Board from 'react-trello';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

import $ from 'jquery';
window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');

var session = sessionStorage.getItem('health_facilities_name');
const Config = require('../../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";

class BoardHemovigilancia extends Component {
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			data:{
				lanes: [
				    {
				      	id: 'lane1',
				      	title: 'Unidades Enviadas',
				      	label: '0',
				      	cards: [],
				      	className:"col-xs-12 col-sm-4",
				      	style:{float:'none'}
				    },
				    {
				      	id: 'lane2',
				      	title: 'Transfusión Iniciada',
				      	label: '0/0',
				      	cards: [],
				      	className:"col-xs-12 col-sm-4",
				      	style:{float:'none'}
				    },
				    {
				      	id: 'lane3',
				      	title: 'Transfusión Terminada',
				      	label: '0/0',
				      	cards: [],
				      	className:"col-xs-12 col-sm-4",
				      	style:{float:'none'}
				    }
			  	],
			  	//style:{marginLeft:'5%'}
			},
			top_board:"",
		}
	}

	componentWillMount(){
		this._mounted = true;
		var search = this.props.match.url.replace('/', '');

		//Actualizar listado por mensaje del servidor
      	_hub = $.hubConnection(ChatUrl, {
        	useDefaultPath: false
      	});

      	ChatProxy = _hub.createHubProxy('ChatHub');
      	ChatProxy.getItems = this.getList;

      	ChatProxy.on("addNewMessageToPage", function(name, message) {
	        if(message === "refresh_hemo_board" && search.indexOf('board_hemovigilancia') !== -1){
	          this.getItems();
	        }
      	});

      	_hub.start()
      	.done(function() {
        	console.log("Connected to Signalr Server");
      	})
      	.fail(function() {
        	console.log("failed in connecting to the signalr server");
      	});

	}

	componentWillUnmount(){
		this._mounted = false;
	}

	componentDidMount(){
		var offsets = $('.react-trello-board').position();
		var result = $(".rc-menu").height();
		var top = offsets.top;
		this.setState({top_board:result-top+'px'});

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)


		this.getList();
	}

	getList(){
		fetch(Config.default.apiGateway.URL+'unit_delivered/get_list_dashboard?hf_id=1',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var data = this.state.data;
				data.lanes.map((lane)=>{
					lane.cards = [];
				});
				response.map((res, i)=>{
					var fecha = moment(res.register_date).format('DD/MM/YYYY')+' '+
								moment(res.register_hour, 'H:mm:ss').format('HH:mm');
					var card = {
						id:res.id.toString(),
						title:'',
						label:'Fecha-Hora de Envío: '+fecha,
						draggable: false,
						style:{backgroundColor: res.color === 'RED' ? '#ec6874' : 
												res.color === 'WHITE' ? '#ffffff' : 
												res.color === 'YELLOW' ? '#eccb27' : '#41cf41', maxWidth:'100%'},
						className:"react-trello-card col-xs-12",
						description:<div>
							<label style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>Unidad</label>
							<span style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>{res.unit_number}</span>
							<label style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>Paciente</label>
							<span style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>{res.patient}</span>
							<label style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>Servicio</label>
							<span style={{display:'block', color:res.color !== 'WHITE' ? 'white' : 'black'}}>{res.service}</span>
						</div>,
						unit:res.unit_number
					}
					data.lanes[res.column - 1].cards.push(card);					
					
				});
				
				data.lanes.map((lane)=>{
					lane.label = lane.cards.length.toString();
				});
				
				this.setState({data:data});

				$('.react-trello-board').children('div').addClass('col-xs-12');
				$('.react-trello-card').parent('span').parent('div').parent('div').addClass('col-xs-12');
				$('.react-trello-card').each(function(i){
					$(this).children('header').children('span').eq(1).addClass('moving');
					$(this).children('header').children('div').remove();
					if($(this).css('background-color') !== 'rgb(255, 255, 255)'){
						$(this).children('header').css('color','white');
					}
					
				});
					
					
			}
		});
	}

	handleChange(e){
		var value = e.target.value;
		this.setState({[e.target.name]: value});

		var data = this.state.data;
		data.lanes.map((lane)=>{
			var cont = 0;
			lane.cards.map((card)=>{
				if(card.unit.indexOf(value) === -1){
					$('.react-trello-card').each(function(i){
						if($(this).attr('data-id') === card.id){
							$(this).css('display', 'none');
						}
					});
				}else{
					$('.react-trello-card').each(function(i){
						if($(this).attr('data-id') === card.id){
							$(this).css('display', 'block');
						}
					});
					cont++;
				}
			});

			lane.label = cont.toString();
		});
	}

  	render() {
	  	const {t} = this.props;
	    return (
	    	<div className="col-xs-12">
	    		<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						{t('sidebar.nav.patients.board')}
					</h5>
				</div>
				<div className="col-xs-12 col-sm-9" style={{marginLeft:'12%'}}>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-4" style={{paddinfLeft:'9px', marginLeft:'3px', paddingRight:'0px'}}>
							<span>Busqueda</span>
							<input name="search" id="search" value={this.state.search}
								onChange={this.handleChange} className="form-control" placeholder="No. Unidad" />
						</div>
					</div>
		    		<Board 
		    			data={this.state.data} 
		    			style={{
		    				backgroundColor: 'white',//'rgba('+this.props.background_color+', 0.7)',
		    				position:'relative',
		    				//top:this.state.top_board,
		    				overflowY:'unset'
		    			}}
		    			
		    		/>
	    		</div>
	    	</div>
	    ) 
    	
  	}
}

export default translate('translations')(BoardHemovigilancia);